module.exports = __webpack_public_path__ + "img/why-icon-1.b335966a.svg";